import { ApiResourceBaseClass as t } from "./baseApiCalls.js";
const o = "provider";
class n extends t {
  /**
   * Searches for providers based on a query string and optional pagination.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/provider/search`
   *
   * @param {string} q - The query string used to search for providers.
   * @param {number} [page] - (Optional) The page number for paginated results.
   * @returns {Promise<FuzzySearchProviderReceivedData>} A promise resolving to the data containing the search results.
   */
  searchProviders = async (s, r) => {
    const e = { q: s, page: r }, { data: a } = await this.get(
      `${o}/search`,
      e
    );
    return a;
  };
}
export {
  o as PROVIDER_RESOURCE_URI,
  n as Provider
};
